import { sendMessage } from '../../widget/fitroomWidget';
import {
  FitroomAvatarFromSmplReqPayload,
  FitroomAvatarSex,
  FitroomMessageType,
} from '../../widget/fitroomWidgetTypes';

export function sendFitroomAvatarReq() {
  const smplShape: number[] = [];
  for (let i = 0; i < 300; i++) {
    smplShape.push(1);
  }
  const payload: FitroomAvatarFromSmplReqPayload = {
    sex: FitroomAvatarSex.MALE,
    smplShape,
  };
  sendMessage({ type: FitroomMessageType.AVATAR_FROM_SMPL_REQ, payload });
}

export function sendFitroomGarmentReq(id: string, isSizeRecommendation: boolean) {
  const payload = { id, isSizeRecommendation };
  sendMessage({ type: FitroomMessageType.GARMENT_REQ, payload });
}

export function sendFitroomSessionReq() {
  const payload = '256ccf17-f443-4bac-a356-235e63f0101f';
  sendMessage({ type: FitroomMessageType.SESSION_REQ, payload });
}
